import React from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import ButtonBase, { ButtonBaseProps } from "@material-ui/core/ButtonBase";
import clsx from "clsx";
import btnLeftImgSrc from "assets/images/icons/btn_left.png";
import btnRightImgSrc from "assets/images/icons/btn_right.png";
import { buttonHoverOpacity } from "theme";

const useStyles = makeStyles((theme: Theme) => {
    return createStyles({
        root: {
            flex: "1 0 auto",
            width: theme.spacing(4),
            borderRadius: "50%",
            "&:hover": {
                opacity: buttonHoverOpacity,
            },
            "& img": {
                width: "100%",
            },
        },
        disabled: {
            "& img": {
                filter: "grayscale(100%)",
            },
        },
    });
});

type PaginationButtonVariant = "previous" | "next";

interface IProps extends ButtonBaseProps {
    variant: PaginationButtonVariant;
}

export default function PaginationButton(props: IProps) {
    const { variant, className, disabled = false, ...rest } = props;
    const classes = useStyles();

    return (
        <ButtonBase
            className={clsx(className, classes.root, { [classes.disabled]: disabled })}
            disabled={disabled}
            {...rest}
        >
            <img src={variant === "previous" ? btnLeftImgSrc : btnRightImgSrc} alt="" />
        </ButtonBase>
    );
}
